import script from "./ListOfDuplicatedUploadsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListOfDuplicatedUploadsModal.vue?vue&type=script&setup=true&lang=ts"

import "./ListOfDuplicatedUploadsModal.vue?vue&type=style&index=0&id=005830ad&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-005830ad"]])

export default __exports__